const status = {
  TO_COLLECT: {
    progress: 0,
    color: "blue",
    name: "En preparación",
    description: "El vendedor está preparando tu pedido.",
    message: "El vendedor está preparando tu pedido. Te enviaremos un mail ni bien tengamos tu envío en nuestras manos y esté listo para ser despachado.",
    waiting: "Esperando preparación...",
    blocking: true,
  },
  COLLECTED: {
    progress: 1,
    color: "blue",
    name: "En nuestras manos",
    description: "Retiramos tu pedido del domicilio del vendedor.",
    message: "Ya retiramos tu pedido del domicilio del vendedor, y está camino a nuestro centro de distribución. Te enviaremos un mail ni bien esté listo para ser despachado.",
    waiting: "Esperando despacho..."
  },
  TO_RECOVER: {
    progress: 0,
    color: "blue",
    name: "A rescatar",
    description: "Recibimos la orden de retirar un paquete en tu domicilio.",
    message: "Retiraremos un paquete en tu domicilio. Te enviaremos un mail ni bien nuestro transportista esté en camino. Recordá tenerlo preparado, en su empaque original y tal cual lo recibiste.",
    waiting: "Esperando retiro..."
  },
  RECOVERED: {
    progress: 1,
    color: "blue",
    name: "Rescatado",
    description: "Retiramos tu paquete en tu domicilio.",
    message: "Ya retiramos tu paquete en tu domicilio y está camino a nuestro centro de distribución, a la espera de ser retornado.",
    waiting: "Retornando..."
  },
  TO_RECEIVE: {
    progress: 0,
    color: "blue",
    name: "A recibir",
    description: "Estamos aguardando que entregues tu devolución en el correo.",
    message: "Acercate a una sucursal del correo con el paquete que querés devolver. Recordá empaquetarlo y etiquetarlo correctamente con la etiqueta que te brindamos.",
    waiting: "Esperando paquete..."
  },
  RECEIVED: {
    progress: 1,
    color: "blue",
    name: "Recibido",
    description: "El correo nos informó que ya entregaste tu devolución.",
    message: "Tu devolución ya fue recibida en el correo, y prontó será enviada a nuestro centro de distribución, para finalmente ser retornada al vendedor.",
    waiting: "Esperando retorno..."
  },
  TO_DELIVER: {
    progress: 1,
    color: "blue",
    name: "Listo para despachar",
    description: "Recibimos tu pedido en nuestro centro de distribución.",
    message: "Tu pedido ya está en nuestro centro de distribución, listo para ser despachado. Te enviaremos un mail ni bien el repartidor esté camino a tu domicilio.",
    waiting: "Esperando despacho..."
  },
  PICK_UP: {
    progress: 1,
    color: "blue",
    name: "Listo para retirar",
    description: "Recibimos tu pedido en la sucursal de tu localidad.",
    message: "Tu pedido ya está en la sucursal de tu localidad, listo para que lo retires. ¡No te duermas! tenés 5 días hábiles para retirarlo, desde la fecha de arribo.",
    waiting: "Esperando retiro..."
  },
  DELIVERED: {
    progress: 3,
    color: "green",
    name: "¡Entregado!",
    description: "Entregamos tu pedido en tu domicilio.",
    message: "¡Listo! Esperamos hayas disfrutado la experiencia Jipink. Cualquier duda o sugerencia comunicate con nosotros. ¡Gracias!"
  },
  TO_RETURN: {
    progress: 1,
    color: "blue",
    name: "A retornar",
    description: "Recibimos tu paquete en nuestro centro de distribución.",
    message: "Tu paquete ya está en nuestro centro de distribución, listo para ser retornado al vendedor.",
    waiting: "Esperando retorno..."
  },
  RETURNED: {
    progress: 3,
    color: "green",
    name: "Retornado",
    description: "Retornamos tu paquete al domicilio del vendedor.",
    message: "Tu paquete ya está en manos del vendedor. Esperamos hayas disfrutado la experiencia Jipink. Cualquier duda o sugerencia comunicate con nosotros. ¡Gracias!"
  },
  CANCELED: {
    progress: 3,
    color: "gray",
    name: "Cancelado",
    description: "Tu pedido fue cancelado.",
    message: "Tu pedido fue cancelado, por lo que no pasaremos por tu domicilio. Si pensás que fue cancelado por error, comunicate con nosotros. ¡Hasta la próxima!"
  },
  BLOCKED: {
    progress: 1,
    color: "orange",
    name: "En Espera",
    description: "El vendedor está analizando tu caso para darle solución.",
    message: "El vendedor está validando tus datos y verificando tu pedido. Se estará comunicando con vos ante cualquier inconveniente detectado. ¡Gracias por tu paciencia!",
    waiting: "Esperando resolución...",
    blocking: true
  },
  ADMITTED: {
    progress: 1,
    color: "blue",
    name: "Recibido por el correo",
    description: "Tu pedido ya llegó al centro de distribución del correo.",
    message: "Tu pedido ya llegó al centro de distribución del correo. Te enviaremos un mail cuando estén en camino a tu domicilio.",
    waiting: "Esperando despacho..."
  },
  CONFIRMED: {
    progress: 1,
    color: "blue",
    name: "¡Visita en camino!",
    description: "El repartidor está camino a tu domicilio.",
    message: "El repartidor ya está en camino y llegará en unos instantes. Asegurate que haya alguien mayor de 18 años para recibirlo.",
    waiting: "Esperando visita..."
  },
  NOT_VISITED: {
    progress: 1,
    color: "orange",
    name: "No visitado",
    description: "El repartidor no pudo visitar el domicilio.",
    message: "El repartidor reportó un inconveniente y no pudo visitar el domicilio. Te estará contactando a la brevedad para poder coordinar la entrega.",
    waiting: "Esperando reintento...",
    issue: true,
  },
  ABORTED: {
    progress: 3,
    color: "gray",
    name: "Interrumpido",
    description: "Tu pedido está en proceso de cancelación.",
    message: "Tu pedido fue cancelado, por lo que no pasaremos por tu domicilio. Si pensás que fue cancelado por error, comunicate con nosotros. ¡Hasta la próxima!"
  },
  EXPIRED: {
    progress: 3,
    color: "gray",
    name: "No retirado",
    description: "Tu pedido no fue retirado y está en proceso de retorno.",
    message: "Tu pedido no fue retirado a tiempo, por lo que retornará nuevamente al origen. ¡Hasta la próxima!"
  },
  TO_APPROVE: {
    progress: 0,
    color: "blue",
    name: "A confirmar",
    description: "Tu operación aún no fue confirmada.",
    message: "Tu operación debe ser abonada por algunos de los medios de pago habilitados para poder continuar con la misma.",
    waiting: "Esperando pago..."
  },
  UNSUPPORTED: {
    progress: 0,
    color: "red",
    name: "¡Ups!",
    description: "Error inesperado.",
    message: "Debido a un error de nuestro sistema no podemos reportar el estado de tu pedido en este momento. Por favor, intentá nuevamente en unos minutos",
    waiting: "Esperando novedades..."
  },
  EXPRESS: {
    DISPATCHED: {
      progress: 1,
      color: "blue",
      name: "Despachado",
      description: "Tu domicilio ya está en la ruta de un repartidor.",
      message: "Tu domicilio ya fue asignado a un repartidor y te estará visitando a la brevedad.",
      waiting: "Esperando visita..."
    },
    VISITED: {
      progress: 1,
      color: "blue",
      name: "Visitado",
      description: "El repartidor visitó el domicilio.",
      message: "El repartidor visitó el domicilio pero no pudo concretar la operación. Si es la primera vez que lo intentamos, volveremos a pasar por tu domicilio dentro de las próximas 24 horas.",
      waiting: "Esperando reintento...",
      issue: true,
    },
  },
  STANDARD: {
    DISPATCHED: {
      progress: 1,
      color: "blue",
      name: "En manos del correo",
      description: "El correo ya tiene tu pedido y está camino a su centro de distribución.",
      message: "El correo ya tiene tu pedido y está camino a su centro de distribución, donde será clasificado y luego despachado a tu localidad.",
      waiting: "Esperando arribo a correo..."
    },
    VISITED: {
      progress: 1,
      color: "blue",
      name: "Visitado",
      description: "El correo visitó tu domicilio.",
      message: "El correo nos informó que visitó el domicilio pero no pudo concretar la operación, por lo que tu pedido quedará a resguardo en la sucursal de Correo Argentino más cercana. Te enviaremos un mail ni bien nos informen que podés pasar a retirarlo por la sucursal.",
      waiting: "Esperando arribo a sucursal...",
      issue: true,
    },
  },
}

const issue = {
  BROKEN: {
    description: "Tu paquete está dañado y no puede ser entregado.",
    message: "Lamentablemente, el repartidor tuvo un problema con el paquete. Ya estamos en contacto con el vendedor para buscar una solución.",
  },
  BUSINESS_HOURS: {
    description: "Tu domicilio tiene un horario limitado.",
    message: "Tu domicilio tiene un horario limitado y se encontraba cerrado la momento de ser visitado por el repartidor.",
  },
  CANCELED: {
    description: "Tu pedido fue cancelado, por lo que no volveremos a visitarte.",
    message: "La operación fue cancelada por el usuario o por el sistema, por lo que no se realizará la visita.",
  },
  DUPLICATED: {
    description: "Tu domicilio ya fue visitado anteriormente.",
    message: "La operación fue marcada como duplicada, por lo que no se realizará la visita.",
  },
  INCORRECT_ADDRESS: {
    description: "El repartidor no pudo encontrar la dirección proporcionada.",
    message: "El repartidor no pudo encontrar la dirección proporcionada. Te contactaremos para verificar los datos y coordinar una nueva entrega.",
  },
  LOST: {
    description: "El repartidor reportó un problema con el paquete.",
    message: "Lamentablemente, el repartidor tuvo un problema con el paquete. Ya estamos en contacto con el vendedor para buscar una solución.",
  },
  NOT_VISITED: {
    description: "El repartidor no pudo visitar el domicilio.",
    message: "El repartidor reportó un inconveniente y no pudo visitar el domicilio. Te estará contactando a la brevedad para poder coordinar la entrega.",
  },
  ON_VACATIONS: {
    description: "El domicilio se encuentra cerrado por vacaciones.",
    message: "El domicilio reportado está cerrado por vacaciones. Se reprogramará la entrega una vez que el domicilio esté disponible.",
  },
  OVERSIZE: {
    description: "El paquete es demasiado grande o pesado para ser transportado.",
    message: "El paquete excede las dimensiones o peso permitidos para el transporte. Nos pondremos en contacto para coordinar una solución.",
  },
  REJECTED: {
    description: "Se rechazó la operación en tu domicilio.",
    message: "El repartidor visitó el domicilio, pero la operación fue rechazada o desconocida por la persona que lo recibió.",
  },
  RESCHEDULED: {
    description: "Se reprogramó la visita para una nueva fecha.",
    message: "La entrega fue reprogramada para una nueva fecha. Te enviaremos un mail con los detalles de la nueva entrega.",
  },
  STOLEN: {
    description: "El repartidor reportó un problema con el paquete.",
    message: "Lamentablemente, el repartidor tuvo un problema con el paquete. Ya estamos en contacto con el vendedor para buscar una solución.",
  },
  UNREACHABLE_AREA: {
    description: "Tu domicilio está en una zona de difícil acceso.",
    message: "El domicilio se encuentra en una zona de difícil acceso, por lo que se reprogramará la entrega y se buscarán alternativas.",
  },
  UNREACHABLE_RECEIVER: {
    description: "El repartidor intentó contactarse con vos sin éxito.",
    message: "El repartidor no pudo contactarse con vos a través del teléfono proporcionado, por lo que estaremos verificando tus datos.",
  },
  VEHICLE_ISSUE: {
    description: "El repartidor tuvo un problema con su vehículo.",
    message: "El repartidor reportó un problema con su vehículo, por lo que se reprogramará la visita y te informaremos sobre la nueva fecha.",
  },
  WRONG_PRODUCT: {
    description: "El producto transportado es incorrecto.",
    message: "El producto es incorrecto, por lo que coordinaremos la devolución y el envío del producto correcto.",
  },
  EXHAUSTED: {
    description: "Se agotaron los intentos de visita disponibles.",
    message: "Se agotaron todos los intentos de visita, por lo que no volveremos a pasar por tu domicilio.",
  },
}

export default (m, o) => {
  let response = status.UNSUPPORTED
  if (m in status && o.sub_status in status[m]) {
    response = status[m][o.sub_status]
  } else if (m in status && o.status in status[m]) {
    response = status[m][o.status]
  } else if (o.sub_status in status) {
    response = status[o.sub_status]
  } else if (o.status in status) {
    response = status[o.status]
  }
  if (response.issue && o.issue in issue) {
    response.description = issue[o.issue].description
    response.message = issue[o.issue].message
  }
  return response
}